import { GET_RISK_SCENARIOS_REQUEST } from "../types/riskScenariosTypes";

const initialState = {
  risk_scenarios: [],
  loading: false,
  error: null,
};

const riskScenariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RISK_SCENARIOS_REQUEST:
      return {
        ...state,
        risk_scenarios: action.payload,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
export default riskScenariosReducer;
